import { c as _c } from "react/compiler-runtime";
import { Box } from '@mui/material';
import { useCreditCardCompareOfferContext } from '../OfferContext';
import { ConsContainer } from './Cons.container';
import { ContentText } from './components/ContentText';
export function Cons() {
  const $ = _c(4);
  const {
    offer: t0
  } = useCreditCardCompareOfferContext();
  const {
    consBullets
  } = t0;
  let t1;
  if ($[0] !== consBullets) {
    t1 = consBullets.length > 0 ? consBullets.map(_temp) : "-";
    $[0] = consBullets;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <ConsContainer>{t1}</ConsContainer>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(consBullet, consBulletIndex) {
  return <Box key={consBulletIndex} display="flex" flexDirection="row"><Box aria-hidden="true" component="span" data-testid="CloseIcon" className="mask-icon mask-icon-close" sx={{
      width: {
        xs: "1rem",
        md: "1.5rem"
      },
      height: {
        xs: "1rem",
        md: "1.5rem"
      },
      mr: 2,
      backgroundColor: "reds.main",
      flexShrink: 0
    }} /><ContentText>{consBullet}</ContentText></Box>;
}